import React, {Component} from 'react';
import PropTypes from "prop-types";
import { withFormik, Form, Field } from 'formik';
import api from '../../../utils/api';
import {v4 as uuid} from 'uuid';
import { Scrollbars } from 'react-custom-scrollbars';
import TextareaAutosize from 'react-autosize-textarea';
import ReactQuill from 'react-quill'; // ES6
import 'react-quill/dist/quill.snow.css'; // ES6
/* global $ */

class renderQuizQuestionEdit extends Component {
    constructor(props){
        super(props);

        this.state = {
            files: [],
            hideFiles: []
        }
    }

    onEditorStateChange = (editorState) => {
        this.props.setFieldValue('question', editorState)
 
      };


    //Renders
    renderModalHeader = () => (
        <div className="modal-header bg-light no-border">
            <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={this.props.triggerEditQuestionShowState}
            >
                <span
                    onClick={this.props.triggerEditQuestionShowState}
                    aria-hidden="true"
                >
                    ×
                </span>
            </button>
            <h4
                className="modal-title"
                id="myModalLabel"
            >
                Add Quiz Question
            </h4>
        </div>
    );

    renderConceptNameForm = () => (
        <div className="col-sm-6">
            <div className="form-group">
                <label>
                    Concept Name:
                </label>
                <Field
                    type="text"
                    async={true}
                    className="form-control"
                    name='conceptName'
                />
                {
                    (this.props.touched.conceptName && this.props.errors.conceptName) &&
                    (
                        <p className="help-block">
                            {this.props.errors.conceptName}
                        </p>
                    )
                }
            </div>
        </div>
    );

    renderTimeInVideoForm = () => (
        <div className="col-sm-3">
            <div className="form-group">
                <label>
                    Time In Video
                </label>
                <Field
                    type="text"
                    async={true}
                    className="form-control"
                    name='timeInVideo'
                />
                {
                    (this.props.touched.timeInVideo && this.props.errors.timeInVideo) &&
                    (
                        <p className="help-block">
                            {this.props.errors.timeInVideo}
                        </p>
                    )
                }
            </div>
        </div>
    );

    renderConceptRefersToForm = () => (
        <div className="col-sm-3">
            <div className="form-group">
                <label>
                    Concept Refers To
                </label>
                <Field
                    type="text"
                    async={true}
                    className="form-control"
                    name='conceptRefersTo'
                />
                {
                    (this.props.touched.conceptRefersTo && this.props.errors.conceptRefersTo) &&
                    (
                        <p className="help-block">
                            {this.props.errors.conceptRefersTo}
                        </p>
                    )
                }
            </div>
        </div>
    );

    modules = {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
          
            [{ 'header': 1 }, { 'header': 2 }],               // custom button values
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
            [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent                  // text direction
          
            [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown

          
            [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
          
            ['clean']            
        ],
      }
    
      formats = [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote', 'script',
        'list', 'bullet', 'indent',
        'link', 'image', 'color', 'code-block'
      ]

    renderQuestionForm = () => {
        return (
            <div className="col-sm-12">
                <ReactQuill 
                    value={this.props.values.question}
                    modules={this.modules}
                    placeholder={"Write a question"}
                    formats={this.formats}
                    onChange={val => this.props.setFieldValue('question', val)} 
                />
                <br /><br />
            </div>
        )
        
    }

    renderQuestionFormOld = () => (
        <div className="col-sm-12">
            <div className="form-group">
                <label>
                    Question
                </label>
                <TextareaAutosize
                    component='textarea'
                    async={true}
                    name='question'
                    className="form-control"
                    rows="5"
                />
                {
                    (this.props.touched.question && this.props.errors.question) &&
                    (
                        <p className="help-block">
                            {this.props.errors.question}
                        </p>
                    )
                }
            </div>
        </div>
    );

    readFile = (file) => {
        var fr = new FileReader();
        fr.onload = function () {
            $('[data-file="'+ file.name +'"]').attr('src', fr.result);
        }
        fr.readAsDataURL(file);

    }

    renderAddPictureForm = () => (
        <div className="col-sm-12">


            {this.state.files.map((f, fi) => {
                if(f.type.indexOf("image") > -1){
                    this.readFile(f);
                    return (
                        <div className="file-preview-container">
                            <button className={"btn btn-delete"}
                                    onClick={(e) => {
                                        let {files} = this.state;
                                        files.splice(fi, 1);
                                        this.setState({files});
                                    }}
                            ><i className={"zmdi zmdi-close"}
                            /></button>
                            <img src={""} data-file={f.name} className="chapter-file-preview" /></div>
                    )
                }else if(f.type.indexOf("zip") > -1){
                    return (
                        <div className="file-preview-container">
                            <button className={"btn btn-delete"}
                                    onClick={(e) => {
                                        let {files} = this.state;
                                        files.splice(fi, 1);
                                        this.setState({files});
                                    }}
                            ><i className={"zmdi zmdi-close"} /></button>
                            <i className="zmdi zmdi-folder" />
                            <small>{f.name}</small>

                        </div>
                    )
                }else{
                    return (
                        <div className="file-preview-container">
                            <button className={"btn btn-delete"}
                                    onClick={(e) => {
                                        let {files} = this.state;
                                        files.splice(fi, 1);
                                        this.setState({files});
                                    }}
                            ><i className={"zmdi zmdi-close"} /></button>
                            <i className="zmdi zmdi-file" />
                            <small>{f.name}</small>

                        </div>
                    )
                }
            })}

            <button className={"btn btn-file-upload btn-default"} onClick={(e) => {
                e.preventDefault();
                $('#upload-chapter-file').trigger('click');
            }}><i className="zmdi zmdi-plus" /></button>
            <input
                type="file"
                className="btn btn-file-upload btn-default hidden"
                id="upload-chapter-file"
                onChange={(e) => {
                    let {files} = this.state;
                    const data = new FormData();
                    data.append('file', e.target.files[0], "chapter-file-" + new Date().getTime().toString() + e.target.files[0].name);

                    files.push(e.target.files[0]);
                    this.setState({files});
                }}
            />
        </div>
    );

    renderUploadPictureForm = () => {
        const currentQuizQuestionsProps = this.props.quizQuestionsProps.filter((item) => item.id === this.props.selectedId)[0]

        return (
            <div className="col-sm-12">


                {currentQuizQuestionsProps.File &&

                <span>
                                        {currentQuizQuestionsProps.File.map(f => {
                                            if(this.state.hideFiles.filter(hf => hf.id == f.id).length === 0) {

                                                if (f.type.indexOf("image") > -1) {


                                                    return (
                                                        <div className="file-preview-container">
                                                            <button className={"btn btn-delete"}
                                                                    onClick={(e) => {
                                                                        this.props.deleteQuestionFile(f.id);
                                                                        let {hideFiles} = this.state;
                                                                        hideFiles.push(f);
                                                                        this.setState({hideFiles});
                                                                    }}
                                                            ><i className={"zmdi zmdi-close"}/></button>
                                                            <img src={api.makeFileURL(f.url, this.props.user.id)} data-file={f.name}
                                                                 className="chapter-file-preview"/></div>
                                                    )
                                                } else if (f.type.indexOf("zip") > -1) {
                                                    return (
                                                        <a className="file-preview-container" target="_blank"
                                                           href={api.makeFileURL(f.url, this.props.user.id)}>
                                                            <button className={"btn btn-delete"}
                                                                    onClick={(e) => {
                                                                        this.props.deleteChapterFile(f.id);
                                                                        let {hideFiles} = this.state;
                                                                        hideFiles.push(f);
                                                                        this.setState({hideFiles});
                                                                    }}
                                                            ><i className={"zmdi zmdi-close"}/></button>
                                                            <i className="zmdi zmdi-folder"/>
                                                            <small>{f.name}</small>

                                                        </a>
                                                    )
                                                } else {
                                                    return (
                                                        <a className="file-preview-container" target="_blank"
                                                           href={api.makeFileURL(f.url, this.props.user.id)}>
                                                            <button className={"btn btn-delete"}
                                                                    onClick={(e) => {
                                                                        this.props.deleteChapterFile(f.id);
                                                                        let {hideFiles} = this.state;
                                                                        hideFiles.push(f);
                                                                        this.setState({hideFiles});
                                                                    }}
                                                            ><i className={"zmdi zmdi-close"}/></button>
                                                            <i className="zmdi zmdi-file"/>
                                                            <small>{f.name}</small>

                                                        </a>
                                                    )
                                                }
                                            }

                                        })}
                                    </span>}

                {this.state.files.map((f, fi) => {
                    if(f.type.indexOf("image") > -1){
                        this.readFile(f);
                        return (
                            <div className="file-preview-container">
                                <button className={"btn btn-delete"}
                                        onClick={(e) => {
                                            let {files} = this.state;
                                            files.splice(fi, 1);
                                            this.setState({files});
                                        }}
                                ><i className={"zmdi zmdi-close"}
                                /></button>
                                <img src={""} data-file={f.name} className="chapter-file-preview" /></div>
                        )
                    }else if(f.type.indexOf("zip") > -1){
                        return (
                            <div className="file-preview-container">
                                <button className={"btn btn-delete"}
                                        onClick={(e) => {
                                            let {files} = this.state;
                                            files.splice(fi, 1);
                                            this.setState({files});
                                        }}
                                ><i className={"zmdi zmdi-close"} /></button>
                                <i className="zmdi zmdi-folder" />
                                <small>{f.name}</small>

                            </div>
                        )
                    }else{
                        return (
                            <div className="file-preview-container">
                                <button className={"btn btn-delete"}
                                        onClick={(e) => {
                                            let {files} = this.state;
                                            files.splice(fi, 1);
                                            this.setState({files});
                                        }}
                                ><i className={"zmdi zmdi-close"} /></button>
                                <i className="zmdi zmdi-file" />
                                <small>{f.name}</small>

                            </div>
                        )
                    }
                })}

                <button className={"btn btn-file-upload btn-default"} onClick={(e) => {
                    e.preventDefault();
                    $('#upload-chapter-file').trigger('click')
                }}><i className="zmdi zmdi-plus" /></button>
                <input
                    type="file"
                    className="btn btn-file-upload btn-default hidden"
                    id="upload-chapter-file"
                    onChange={(e) => {
                        let {files} = this.state;
                        const data = new FormData();
                        data.append('file', e.target.files[0], "chapter-file-" + new Date().getTime().toString() + e.target.files[0].name);

                        files.push(e.target.files[0]);
                        this.setState({files});
                    }}
                />
            </div>
        )
    }

    renderOption = (option, index) => {
        return (
            <div className="col-md-12" key={index}>
                <div className="form-group">
                    <label>Option {option.letter}</label>
                    <ReactQuill 
                        value={this.props.values["option" + option.letter]}
                        modules={this.modules}
                        placeholder={"Write a question"}
                        formats={this.formats}
                        onChange={val => this.props.setFieldValue('option' + option.letter, val)} 
                    />
                </div>
            </div>
        )
    }

    renderOptionAForm = () => (
        <div className="col-sm-6">
            <div className="form-group">
                <label>
                    Option A
                </label>
                <TextareaAutosize
                    type="text"
                    async={true}
                    className="form-control"
                    name='optionA'
                />
            </div>
        </div>
    );

    renderOptionBForm = () => (
        <div className="col-sm-6">
            <div className="form-group">
                <label>
                    Option B
                </label>
                <TextareaAutosize
                    type="text"
                    async={true}
                    className="form-control"
                    name='optionB'
                />
            </div>
        </div>
    );

    renderOptionCForm = () => (
        <div className="col-sm-6">
            <div className="form-group">
                <label>
                    Option C
                </label>
                <TextareaAutosize
                    type="text"
                    async={true}
                    className="form-control"
                    name='optionC'
                />
            </div>
        </div>
    );

    renderOptionDForm = () => (
        <div className="col-sm-6">
            <div className="form-group">
                <label>
                    Option D
                </label>
                <TextareaAutosize
                    type="text"
                    async={true}
                    className="form-control"
                    name='optionD'
                />
            </div>
        </div>
    );

    renderOptionForm = (letter) => {
        return (
            <div className="col-sm-6">
            <div className="form-group">
                <label>
                    Option {letter}
                </label>
                <TextareaAutosize
                    type="text"
                    async={true}
                    className="form-control"
                    name='optionD'
                    value={this.props.values["option" + letter]}
                    onChange={e => this.props.setFieldValue('option' + letter, e.target.value)}
                />
            </div>
        </div>
        )
    }

    renderCorrectOptionForm = () => (
        <div className="col-sm-12">
            <div className="form-group">
                <label>
                    Correct Option
                </label>
                <div className="form-select-overlay">
                    <select 
                        className="form-control"
                        value={this.props.values.correctOption}
                        onChange={e => this.props.setFieldValue('correctOption', e.target.value)}
                        >
                            <option value="1">A</option>
                            <option value="2">B</option>
                            <option value="3">C</option>
                            <option value="4">D</option>
                    </select>
                </div>
                
                {
                    (this.props.touched.correctOption && this.props.errors.correctOption) &&
                    (
                        <p className="help-block">
                            {this.props.errors.correctOption}
                        </p>
                    )
                }
            </div>
        </div>
    );

    save = () => {
        setTimeout(() => {
            
            let fields = {
                ...this.props.values
            }

            if(this.props.selectedId){
                this.props.onQuizQuestionUpdate(this.props.selectedId, fields, this.state.files, this.props.user.id);
            }else{
                this.props.saveQuizQuestion(fields, this.state.files, this.props.user.id);
                this.props.onQuizQuestionAdd(
                    {
                        ...fields,
                        id: uuid()
                    }
                );
            }
            this.props.triggerEditQuestionShowState();
            //resetForm();

        }, 200)
    }

    render(){
        const options = [
            {letter: 'A', number: 1},
            {letter: 'B', number: 2},
            {letter: 'C', number: 3},
            {letter: 'D', number: 4},
        ]
        return (
            <div
                className="modal fade in"
                id="AddQuizQuestion"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="myModalLabel"
            >
                <div
                    className="add_quiz_question_modal_wrapper"
                    onClick={this.props.triggerEditQuestionShowState}
                />
                <div
                    className="modal-dialog modal-lg"
                    role="document"
                >
                    <Scrollbars style={{ height: "calc(100vh - 100px)" }}>
                    <div className="modal-content">

                        {this.renderModalHeader()}

                        <div className="modal-body no-padding">
                            <div className="sp-20">
                                <div className="row">

                                    {this.renderConceptNameForm()}
                                    {this.renderTimeInVideoForm()}
                                    {this.renderConceptRefersToForm()}
                                    {this.renderQuestionForm()}
                                    {this.props.selectedId ? this.renderUploadPictureForm() : this.renderAddPictureForm()}
                                    </div>
                                    <br /><br />
                                    <div className="row">
                                    {options.map((option, i) => {
                                        return this.renderOption(option, i)
                                    })}
                                    
                                    </div>
                                    <div className="row">
                                    {this.renderCorrectOptionForm()}

                                </div>
                            </div>
                            <div className="text-right bg-dd sp-10">
                                <button
                                    type="button"
                                    className='btn btn-default'
                                    data-dismiss="modal"
                                    onClick={this.props.triggerEditQuestionShowState}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-base"
                                    onClick={this.save}
                                >
                                    Save Changes
                                </button>
                            </div>
                        </div>


                    </div>
                    </Scrollbars>
                </div>
            </div>
        )
    }
}



const EditQuizQuestionModal = withFormik({
    mapPropsToValues({
                         quizQuestionsProps,
                         selectedId,
                         conceptName,
                         timeInVideo,
                         conceptRefersTo,
                         question,
                         optionA,
                         optionB,
                         optionC,
                         optionD,
                         correctOption
                     })
    {
        let currentQuizQuestionsProps = {};
        if(selectedId){
            currentQuizQuestionsProps = quizQuestionsProps.filter((item) => item.id === selectedId)[0];
        }
 
        return {
            conceptName: conceptName || currentQuizQuestionsProps.conceptName || '',
            timeInVideo: timeInVideo || currentQuizQuestionsProps.timeInVideo || 0,
            conceptRefersTo: conceptRefersTo || currentQuizQuestionsProps.conceptRefersTo || '',
            question: question || currentQuizQuestionsProps.question || '',
            optionA: optionA || currentQuizQuestionsProps.optionA || '',
            optionB: optionB || currentQuizQuestionsProps.optionB || '',
            optionC: optionC || currentQuizQuestionsProps.optionC || '',
            optionD: optionD || currentQuizQuestionsProps.optionD || '',
            correctOption: correctOption || currentQuizQuestionsProps.correctOption || 1
        };
    },

    handleSubmit(values, {setErrors, setSubmitting, props}) {
        setTimeout(() => {
            if (values.email === 'test@test.io') {
                setErrors({ email: 'This email is already token' })
            }
            else {
                props.triggerEditQuestionShowState();
                props.onQuizQuestionUpdate(
                    props.selectedId,
                     {
                         ...values,
                         question: values.question.getCurrentContent(),
                         correctOption: +values.correctOption
                     }
                );
            }
        }, 200)
    }
})(renderQuizQuestionEdit);


EditQuizQuestionModal.propTypes = {
    onQuizQuestionUpdate: PropTypes.func.isRequired,
    quizQuestionsProps: PropTypes.array.isRequired,
    selectedId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    triggerEditQuestionShowState: PropTypes.func.isRequired
};

export default EditQuizQuestionModal;


// WEBPACK FOOTER //
// ./src/components/EditChapterPart/FormModals/EditQuizQuestionModal.js